import React from 'react';

const Dashboard = () => {
  return <section className="section"></section>;
};

export default Dashboard;
